import { date, mixed, string } from "yup";

const minAge = 18;
const eighteenYearsAgo = new Date();
eighteenYearsAgo.setFullYear(eighteenYearsAgo.getFullYear() - minAge);

export const emailValidation = {
  'email': string().email('Invalid email format').required('Email is required')
};

export const birthdayValidation = {
  'birthday': date().required('Birthday is required')
    .max(eighteenYearsAgo, 'You must be at least 18 years old')
    .typeError('Invalid date')
};

const passwordSchema = string()
  .required('Password is required')
  .min(8, 'Password must be at least 8 characters long')
  .matches(/[a-zA-Z]/, 'Password must contain at least one letter')
  .matches(/[0-9]/, 'Password must contain at least one number');

export const passwordValidation = {
  password: passwordSchema,
};

export const currentPasswordValidation = {
  current_password: passwordSchema,
};

export const countryValidation = {
  'country': mixed().required('Country is required')
};

export const confrimPasswordValidation = {
  'password_confirmation': string().min(8, 'Password must be at least 8 characters long')
    .test('passwords-match', 'Passwords must match', function (value) {
      const { password } = this.parent;
      return value === password;
    }),
};

export const signUpValidations = {
  ...emailValidation,
  ...passwordValidation,
  ...confrimPasswordValidation,
  ...birthdayValidation
};

export const loginValidations = {
  ...emailValidation,
  ...passwordValidation
};

export const passwordAndConfrimPasswordValidations = {
  ...passwordValidation,
  ...confrimPasswordValidation
};